import _objectSpread from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.object.to-string.js";
// import qs from 'qs';
import axios from 'axios';
import { showToast } from 'vant';
import localCache from '@/utils/localCache';
import { CHAR, DEVELOPMENT } from '@/config/common';
import { Status } from '@/interface/api/common';
var HyRequest = /*#__PURE__*/function () {
  function HyRequest(config) {
    var _this$interceptors, _this$interceptors2, _this$interceptors3, _this$interceptors4;
    _classCallCheck(this, HyRequest);
    this.instance = axios.create(config);
    this.interceptors = config.interceptors;
    //拦截器种类一：axios所有实例共享的拦截器
    this.instance.interceptors.request.use(function (config) {
      // console.log('axios所有实例共享的拦截器，请求成功拦截', config);
      if (config.headers) {
        var token = localCache.getItem('token');
        if (token) {
          config.headers.token = token;
        }
      }
      return config;
    }, function (error) {
      // console.log('axios所有实例共享的拦截器，请求失败拦截', error);
      return error;
    });
    this.instance.interceptors.response.use(function (response) {
      // console.log('axios所有实例共享的拦截器，响应成功拦截', response);
      var data = response.data;
      //假设接口返回的code为0为响应成功，为1为响应失败
      if (data.status === '1' || data.code === 200) {
        return data.data;
      } else {
        if (_.eq(process.env.NODE_ENV, DEVELOPMENT)) {
          if (_.eq(data.status, Status.tokenInvalid)) {
            localCache.setItem('token', CHAR.NUL);
            var info = "".concat(data.info, "\u8BF7\u5237\u65B0\u6216\u8DF3\u8F6C\u8DEF\u7531\u5373\u53EF\u6062\u590D");
            showToast(info);
            return;
          }
        } else {
          showToast(data.info);
        }
        return Promise.reject(data.info);
      }
    }, function (error) {
      // console.log('axios所有实例共享的拦截器，响应失败拦截');
      // console.dir(error);
      //响应失败
      return Promise.reject(error);
    });
    //拦截器种类二：创建的当前的axios实例的拦截器，拦截器需要在创建当前实例时通过传参传进来，所以需要扩展构造器接受的参数类型
    this.instance.interceptors.request.use((_this$interceptors = this.interceptors) === null || _this$interceptors === void 0 ? void 0 : _this$interceptors.requestInterceptors, (_this$interceptors2 = this.interceptors) === null || _this$interceptors2 === void 0 ? void 0 : _this$interceptors2.requestInterceptorsCatch);
    this.instance.interceptors.response.use((_this$interceptors3 = this.interceptors) === null || _this$interceptors3 === void 0 ? void 0 : _this$interceptors3.responseInterceptors, (_this$interceptors4 = this.interceptors) === null || _this$interceptors4 === void 0 ? void 0 : _this$interceptors4.responseInterceptorsCatch);
  }
  return _createClass(HyRequest, [{
    key: "request",
    value: function request(config) {
      var _this = this;
      return new Promise(function (resolve, reject) {
        var _config$interceptors;
        //拦截器种类三：具体某个请求的拦截器，拦截器需要在发送请求的时候，通过参数传进来
        if ((_config$interceptors = config.interceptors) !== null && _config$interceptors !== void 0 && _config$interceptors.requestInterceptors) {
          // console.log('具体某个请求的拦截器，请求成功拦截')
          config = config.interceptors.requestInterceptors(config);
        }
        _this.instance.request(config).then(function (res) {
          var _config$interceptors2;
          if ((_config$interceptors2 = config.interceptors) !== null && _config$interceptors2 !== void 0 && _config$interceptors2.responseInterceptors) {
            res = config.interceptors.responseInterceptors(res);
          }
          // console.log('具体某个请求的拦截器，响应成功拦截');
          // console.dir(res);
          resolve(res);
        }).catch(function (err) {
          // console.log('request catch err...');
          // console.dir(err);
          reject(err);
        });
      });
    }
  }, {
    key: "get",
    value: function get(config) {
      return this.request(_objectSpread(_objectSpread({}, config), {}, {
        method: 'GET'
      }));
    }
  }, {
    key: "post",
    value: function post(config) {
      return this.request(_objectSpread(_objectSpread({}, config), {}, {
        method: 'POST'
      }));
    }
  }, {
    key: "delete",
    value: function _delete(config) {
      return this.request(_objectSpread(_objectSpread({}, config), {}, {
        method: 'DELETE'
      }));
    }
  }, {
    key: "patch",
    value: function patch(config) {
      return this.request(_objectSpread(_objectSpread({}, config), {}, {
        method: 'PATCH'
      }));
    }
  }, {
    key: "put",
    value: function put(config) {
      return this.request(_objectSpread(_objectSpread({}, config), {}, {
        method: 'PUT'
      }));
    }
  }]);
}();
export default HyRequest;